import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WsEncuesta } from '@ciptech/classes/ws-encuesta';
import { Observable } from 'rxjs';

@Injectable()
export class WsEncuestaService {

  private endpoint = `/api/WsEncuestaSatisfaccion`;

  constructor(private http: HttpClient) { }

  getEncuesta(hash: string): Observable<any> {
    // const headers = { context: '.wk-user' };
    return this.http.get<any>(`${this.endpoint}/${hash}`);
  }

  EnviarEncuesta(encuesta: WsEncuesta, context?): Observable<any> {

    /* const formData = new FormData();
    formData.append('contacto', JSON.stringify(contacto));

    if (cliente) formData.append('cliente', JSON.stringify(cliente));
    if (contacto.avatar) formData.append('avatar', contacto.avatar);
    delete contacto.avatar; */

    return this.http.post<any>(`${this.endpoint}`, { encuesta }, { headers: { context: context || 'body' } });
  }

  

}
